const format24HourTime = (timeString) => {
  const [hourPart, minutePart] = timeString.split(":");
  const hour24 = Number(hourPart);
  const ampm = hour24 >= 12 ? "pm" : "am";
  const hour12 = hour24 % 12 || 12;
  return `${hour12}:${minutePart}${ampm}`;
};

export const convertTimeOffered = (start_time, end_time, days) => {
  // check if parameters are undefined
  if (
    start_time === undefined ||
    end_time === undefined ||
    days === undefined
  ) {
    return;
  }
  const daysOfWeek = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
  const daysBeingOffered = [];
  daysOfWeek.forEach((day) => {
    if (days[day]) {
      daysBeingOffered.push(day.charAt(0).toUpperCase() + day.slice(1));
    }
  });
  if (daysBeingOffered.length > 1) {
    return "Varies";
  }

  return `${format24HourTime(start_time)} - ${format24HourTime(end_time)}`;
};
